import { useState } from "react";
import { ApiResponse, makeApiRequest } from "../utilities";
import { GenericObjectInterface } from "../utilities";
import { toast } from "react-toastify";
interface UsePostResult<T> {
    data: T | null;
    loading: boolean;
    error: string | null;
    postData: (endpoint: string, body?: any, headers?: GenericObjectInterface, successMessage?: string) => Promise<void>;
}

export function UsePostResult<T = any>(): UsePostResult<T> {
    const [data, setData] = useState<T | null>(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const postData = async (
        endpoint: string,
        body: any = null,
        headers: GenericObjectInterface = {},
        successMessage?: string

    ) => {
        setLoading(true);
        setError(null);

        try {
            const response: ApiResponse<T> = await makeApiRequest<T>("POST", endpoint, body, headers);
            setData(response.data);
            successMessage && toast.success(successMessage || "Data posted successfully");

        } catch (err: any) {
            console.log("err", err);

            setError(err.response.data.error.message || "Server Error");
            toast.error(err.response.data.error.message || "Server Error");
        } finally {
            setLoading(false);
        }
    };

    return { data, loading, error, postData };
}
